export default __webpack_public_path__ + "static/media/star.8463b178.svg";